CheckoutV2.PaymentV2.ModalGiftCard = function(checkout) {
    var giftCardModal = this;

    this.$modal = $('#applyGiftCardModal');
    this.$inputCardNumber = $('#gift-card-number');
    this.$errorContainer = $('#gift-card-error');
    this.$loadingContainer = $('#add-gift-card-overlay');

    this.request = null;
    this._onCardAdded = function() {};

    this._init = function() {
        giftCardModal._listen();
    };

    this._listen = function() {
        giftCardModal.$modal.find('.js-apply-gift-card-btn').on('click', function(e){
            e.preventDefault();

            var cardID = giftCardModal.$inputCardNumber.val();
            giftCardModal.$loadingContainer.show();
            giftCardModal._validateGiftCard(cardID);
        });
    };

    this._validateGiftCard = function(cardID) {
        if(giftCardModal.request) {
            giftCardModal.request.abort();
        }

        giftCardModal.request = checkout.remote.call({
            'data': {
                'step': 'payment',
                'action': 'addGiftCard',
                'cardID': cardID
            }
        })
            .done(function(response) {
                giftCardModal.$errorContainer.hide();
                giftCardModal._onCardAdded(response.data.balance);
            })
            .fail(function(request) {
                var content = '';
                if (request.responseText) {
                    content = request.responseText;
                } else {
                    content = 'Gift card does not exist or has no remaining balance.'
                }
                giftCardModal.$errorContainer.find('.msg-text').html(content);
                giftCardModal.$errorContainer.show();
            })
            .always(function() {
                giftCardModal.$loadingContainer.hide();
            });
    };

    this.setCardAddedCallback = function(callback) {
        giftCardModal._onCardAdded = callback;
    };

    this.show = function() {
        giftCardModal.$modal.modal('show');
    };

    this.hide = function() {
        giftCardModal.$modal.modal('hide');
    };

    this._init();
};